import { Injectable } from '@angular/core';
import {
	Storage,
	ref,
	deleteObject,
	UploadResult,
	uploadBytes,
	UploadTask,
	uploadBytesResumable,
	percentage,
	listAll,
	getDownloadURL,
	getMetadata,
} from '@angular/fire/storage';
import * as uuid from 'uuid';
import { TenantSettingService } from '../tenantSetting/tenant-setting.service';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class FileService {
	baseAttachementsPath: string;
	baseImagesPath: string;
	baseTemplateAttachmentsPath: string;
	constructor(
		private tenantSettingService: TenantSettingService,
		private storage: Storage,
	) {
		this.tenantSettingService.getTenantSetting().valueChanges.subscribe((tenantSettingResult) => {
			this.baseAttachementsPath = 'attachments/' + tenantSettingResult.data.tenantSetting.tenantId;
			this.baseImagesPath = 'images/' + tenantSettingResult.data.tenantSetting.tenantId;
			this.baseTemplateAttachmentsPath = 'template-attachments/' + tenantSettingResult.data.tenantSetting.tenantId;
		});
	}

	uploadFile(file: File): {
		uploadTask: UploadTask;
		percentageChanges: Observable<any>;
	} {
		const extension = file.name.split('.').pop()?.toLowerCase() || 'pdf';
		const filename = uuid.v4() + '.' + extension;
		const fullPath = `${this.baseAttachementsPath}/${filename}`;
		const storageRef = ref(this.storage, fullPath);
		const uploadTask = uploadBytesResumable(storageRef, file);

		return {
			uploadTask,
			percentageChanges: percentage(uploadTask),
		};
	}

	uploadTemplateAttachment(file: File): {
		uploadTask: UploadTask;
		percentageChanges: Observable<any>;
	} {
		const extension = file.name.split('.').pop()?.toLowerCase() || 'pdf';
		const filename = uuid.v4() + '.' + extension;
		const fullPath = `${this.baseTemplateAttachmentsPath}/${filename}`;
		const storageRef = ref(this.storage, fullPath);
		const uploadTask = uploadBytesResumable(storageRef, file);

		return {
			uploadTask,
			percentageChanges: percentage(uploadTask),
		};
	}

	uploadImageFile(
		file: File,
		labelId?: string,
	): {
		uploadTask: UploadTask;
		percentageChanges: Observable<any>;
	} {
		const extension = file.name.split('.').pop()?.toLowerCase() || 'jpg';
		const filename = uuid.v4() + '.' + extension;
		const imagePath = labelId ? `${labelId}` : 'images';
		const fullPath = `${this.baseImagesPath}/${imagePath}/${filename}`;
		const storageRef = ref(this.storage, fullPath);
		const uploadTask = uploadBytesResumable(storageRef, file);

		return {
			uploadTask,
			percentageChanges: percentage(uploadTask),
		};
	}

	getImageFiles(labelId?: string): Promise<any> {
		const imagePath = labelId ? `${labelId}` : 'images';
		const fullPath = `${this.baseImagesPath}/${imagePath}`;
		const storageRef = ref(this.storage, fullPath);
		return listAll(storageRef);
	}

	getDownloadURL(storageRef: any) {
		return getDownloadURL(storageRef);
	}

	deleteFile(reference: string) {
		const fileRef = ref(this.storage, reference);
		return deleteObject(fileRef);
	}

	async fileExists(reference: string): Promise<boolean> {
		try {
			const fileRef = ref(this.storage, reference);
			await getMetadata(fileRef);
			return true;
		} catch {
			return false;
		}
	}
}
